import { FileTypeValidatorConfiguration } from '../index';
import _last from 'lodash.last';
import { AnnotationShape } from '../../typings/common';
import { NotificationResult } from '../../typings/notification';

export const fileTypeValidator = (
  validatorConfiguration: string,
  shape: AnnotationShape,
  printPositionName: string
): NotificationResult | undefined => {
  const validatorName = 'fileTypeValidator';
  const vectorFileValidatorName = 'vectorFileValidator';

  let {
    validFileExtensions,
    // eslint-disable-next-line prefer-const
    isTrueVectorFile,
  }: FileTypeValidatorConfiguration = JSON.parse(validatorConfiguration);

  if (validFileExtensions.length > 0) {
    validFileExtensions = validFileExtensions.map((name) => name.toLowerCase());
    validFileExtensions = validFileExtensions
      .map((name) => name.toLowerCase())
      .filter((ext) => ext !== '.svg' && ext !== 'svg');
  }

  if (shape.kind === 'Logo') {
    const { fileName, isVectorFileTrueVectorFile } = shape;
    const partsOfFileName: string[] = fileName?.split('.') as string[];
    let fileExtension = '.' + _last(partsOfFileName);

    if (fileExtension !== undefined) {
      fileExtension = fileExtension.toLowerCase();
    }

    const isValidFileExtension: boolean =
      fileExtension === undefined
        ? false
        : validFileExtensions.includes(fileExtension);

    if (
      fileExtension === '.ai' ||
      fileExtension === '.pdf' ||
      fileExtension === '.eps'
    ) {
      const isTrueVectorFileResult = isTrueVectorFile
        ? isVectorFileTrueVectorFile
        : true;

      return {
        shapeId: shape.id,
        validatorName:
          isValidFileExtension && !isVectorFileTrueVectorFile
            ? vectorFileValidatorName
            : validatorName,
        validatorColor:
          isValidFileExtension && isTrueVectorFileResult ? 'Green' : 'Red',
        message: validFileExtensions.join(',').replaceAll('.', ''),
        printPositionName,
      };
    }

    return {
      shapeId: shape.id,
      validatorName,
      validatorColor: isValidFileExtension ? 'Green' : 'Red',
      message: validFileExtensions.join(',').replaceAll('.', ''),
      printPositionName,
    };
  }

  return undefined;
};
